import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import CryptoJS from 'crypto-js';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import Input from 'material-ui/TextField';
import './styles.scss';
import Notification from './../../components/Notification/';
import * as actions from './../../data/login/actions';
import * as settingactions from './../../data/settings/actions';
import { JWTOKEN, MOCK_MODE } from '../../data/constants';
import Logo from './../../components/Logo/';
import { fetchVersionAsync } from '../../utilities/helpers';
import { useLanguage } from '../../context/LanguageContext';

const Login = props => {
  const { labels } = useLanguage();
  const login = labels.login || {};
  const commonLabels = labels.commonLabels || {};
  const [user, setUser] = useState(0);
  const [pass, setPass] = useState('');
  const [showSnackBar, setShowSnackBat] = useState(false);
  const [error, setError] = useState({});
  const [version, setVersion] = useState(null);

  useEffect(() => {
    let isMounted = true;
    fetchVersionAsync()
      .then((version) => {
        if (isMounted) setVersion(version);
      })
      .catch(() => {
        if (isMounted) setVersion('');
      });
    return () => { isMounted = false; };
  }, []);

  useEffect(() => {
    const existingToken = JSON.parse(sessionStorage.getItem(JWTOKEN));
    if (existingToken !== null) {
      const { redirect } = props;
      redirect('home');
    }
  }, []);

  useEffect(() => {
    if (props.error.loginError === true) {
      setError({ loginError: true, message: props.error.message });
      openSnackBar();
    }
  }, [props.error]);

  const openSnackBar = () => {
    setShowSnackBat(true);
  };
  const closeSnackBar = () => {
    setError({ loginError: false, message: '' });
    setShowSnackBat(false);
  };

  const handleStaffID = event => {
    setUser(event.target.value);
  };
  const handlePassword = event => {
    // const plain = CryptoJS.AES.decrypt(hash.toString(), '').toString(CryptoJS.enc.Utf8);
    setPass(CryptoJS.AES.encrypt(event.target.value, 'aDopT').toString());
  };

  const handleLogin = () => {
    const password = pass
      ? CryptoJS.AES.decrypt(pass.toString(), 'aDopT').toString(
          CryptoJS.enc.Utf8
        )
      : '';

    const { fetchLogin, location } = props;
    localStorage.setItem('loginPath', location.pathname);

    fetchLogin(user, password);
  };

  const handleLoginEnter = e => {
    if (e.charCode === 13) {
      handleLogin();
    }
  };

  const inputText = {
    backgroundColor: '#fff',
    height: '45px',
    marginTop: '30px',
    textIndent: '10px',
    width: '300px',
    fontSize: '18px'
  };

  const hintText = {
    left: '75px',
    top: '41px',
    zIndex: 11
  };

  return (
    <main className='Login'>
      <section className='Login-Wrapper'>
        <Logo />
        <article>
          <div className='Login-Wrapper-FloatingLabel'>
            {login.FLOATING_LABEL}
          </div>
          <div className='Login-Input-Holder'>
            <Input
              id='Login-StaffField'
              inputStyle={inputText}
              underlineShow={false}
              hintStyle={hintText}
              floatingLabelFixed
              fullWidth
              onChange={e => handleStaffID(e)}
              onKeyPress={e => handleLoginEnter(e)}
              placeholder={login.STAFF_ID_PLACEHOLDER}
            />
          </div>
          <div className='Login-Input-Holder'>
            <Input
              id='Login-PassField'
              inputStyle={inputText}
              underlineShow={false}
              hintStyle={hintText}
              type='password'
              fullWidth
              onChange={e => handlePassword(e)}
              onKeyPress={e => handleLoginEnter(e)}
              placeholder={login.PASSWORD_PLACEHOLDER}
            />
          </div>
          <div className='Login-Wrapper-Button-Container'>
            <Link to={props.location.pathname} onClick={() => handleLogin()}>
              <div className='Login-Wrapper-Button'>
                <i
                  className='ion ion-android-arrow-forward'
                  aria-hidden='true'
                  style={{ color: '#fff' }}
                />
              </div>
            </Link>
          </div>
        </article>
      </section>
      {(process.env.SERVERLESS || MOCK_MODE) && (
        <p style={{ color: 'white' }}>MOCK SERVER ON</p>
      )}

      <footer className='Login-Footer'>
        <div>
          <figure>
            <img src='assets/img/IBS_Software_logo.png' alt='' />
          </figure>
        </div>
        <div className='Login-Footer-Disclaimer'>
          <span>{login.DISCLAIMER_ITALIC}</span>
          {login.DISCLAIMER_REGULAR}
        </div>
        {version !== null && <div className="subtitle">{commonLabels.VERSION_PREFIX} {version}</div>}
      </footer>
      <Notification
        open={showSnackBar}
        message={error.message}
        closeStatusDisplay={() => closeSnackBar()}
      />
    </main>
  );
};

Login.defaultProps = {
  fetchLogin: function fetchLogin() {},
  location: {},
  redirect: function redirect() {},
  error: {},
  getLanguage: () => {}
};

Login.propTypes = {
  fetchLogin: PropTypes.func,
  location: PropTypes.object,
  redirect: PropTypes.func,
  getLanguage: PropTypes.func,
  error: PropTypes.shape({
    loginError: PropTypes.bool,
    message: PropTypes.string
  })
};

const mapStateToProps = state => ({ ...state.login });

const mapDispatchToProps = dispatch => ({
  fetchLogin: (user, pass) => dispatch(actions.default.fetchLogin(user, pass)),
  redirect: path => dispatch(actions.default.redirect(path)),
  getLanguage: staffId => dispatch(settingactions.getLanguage(staffId))
});

export default connect(mapStateToProps, mapDispatchToProps)(Login);
